export default __webpack_public_path__ + "static/media/logo_claro_completo.d5d81594.png";